class Icons { }
let icons = new Icons()

/** Import used FA icons here **/
import {
    faBan,
    faBarcode,
    faBars,
    faBolt,
    faBroadcastTower,
    faBoxOpen,
    faBullhorn,
    faCaretDown,
    faCaretUp,
    faCheck,
    faCheckCircle,
    faCircleInfo,
    faCirclePlus,
    faClock,
    faCogs,
    faCopy,
    faCube,
    faDesktop,
    faDollyFlatbed,
    faDotCircle,
    faEdit,
    faExclamationCircle,
    faExclamationTriangle,
    faExternalLinkAlt,
    faEye,
    faFilePdf,
    faGlasses,
    faGripLinesVertical,
    faGripVertical,
    faICursor,
    faInbox,
    faIndustry,
    faInfo,
    faLayerGroup,
    faLevelDownAlt,
    faLightbulb,
    faLink,
    faLock,
    faLockOpen,
    faMapMarkedAlt,
    faParachuteBox,
    faPauseCircle,
    faPencil,
    faPlayCircle,
    faPlus,
    faPrint,
    faQuestionCircle,
    faReply,
    faRoute,
    faSearch,
    faSave,
    faShareAlt,
    faShareSquare,
    faSignInAlt,
    faSignOutAlt,
    faSpinner,
    faStarOfLife,
    faStopCircle,
    faStoreAlt,
    faSyncAlt,
    faThumbsDown,
    faThumbsUp,
    faTimes,
    faTimesCircle,
    faTrash,
    faTruck,
    faUndo,
    faUser,
    faUserGraduate,
    faUserTie,
    faCloudUpload,
    faUserCheck,
} from '@fortawesome/free-solid-svg-icons'

import {
    faCalendar,
    faFileAlt,
    faFlag,
    faFrown,
    faCheckSquare,
    faSquare,
} from '@fortawesome/free-regular-svg-icons'

icons[faBan.iconName] = faBan
icons[faBarcode.iconName] = faBarcode
icons[faBars.iconName] = faBars
icons[faBolt.iconName] = faBolt
icons[faBroadcastTower.iconName] = faBroadcastTower
icons[faBoxOpen.iconName] = faBoxOpen
icons[faBullhorn.iconName] = faBullhorn
icons[faCalendar.iconName] = faCalendar
icons[faCaretDown.iconName] = faCaretDown
icons[faCaretUp.iconName] = faCaretUp
icons[faCheck.iconName] = faCheck
icons[faCheckCircle.iconName] = faCheckCircle
icons[faCheckSquare.iconName] = faCheckSquare
icons[faCircleInfo.iconName] = faCircleInfo
icons[faCirclePlus.iconName] = faCirclePlus
icons[faClock.iconName] = faClock
icons[faClock.iconName] = faClock
icons[faCogs.iconName] = faCogs
icons[faCopy.iconName] = faCopy
icons[faCube.iconName] = faCube
icons[faDesktop.iconName] = faDesktop
icons[faDollyFlatbed.iconName] = faDollyFlatbed
icons[faDotCircle.iconName] = faDotCircle
icons[faEdit.iconName] = faEdit
icons[faExclamationCircle.iconName] = faExclamationCircle
icons[faExclamationTriangle.iconName] = faExclamationTriangle
icons[faExternalLinkAlt.iconName] = faExternalLinkAlt
icons[faEye.iconName] = faEye
icons[faFileAlt.iconName] = faFileAlt
icons[faFilePdf.iconName] = faFilePdf
icons[faFlag.iconName] = faFlag
icons[faFrown.iconName] = faFrown
icons[faGlasses.iconName] = faGlasses
icons[faGripLinesVertical.iconName] = faGripLinesVertical
icons[faGripVertical.iconName] = faGripVertical
icons[faICursor.iconName] = faICursor
icons[faInbox.iconName] = faInbox
icons[faIndustry.iconName] = faIndustry
icons[faInfo.iconName] = faInfo
icons[faLevelDownAlt.iconName] = faLevelDownAlt
icons[faLayerGroup.iconName] = faLayerGroup
icons[faLightbulb.iconName] = faLightbulb
icons[faLink.iconName] = faLink
icons[faLock.iconName] = faLock
icons[faLockOpen.iconName] = faLockOpen
icons[faMapMarkedAlt.iconName] = faMapMarkedAlt
icons[faParachuteBox.iconName] = faParachuteBox
icons[faPauseCircle.iconName] = faPauseCircle
icons[faPencil.iconName] = faPencil
icons[faPlayCircle.iconName] = faPlayCircle
icons[faPlus.iconName] = faPlus
icons[faPrint.iconName] = faPrint
icons[faQuestionCircle.iconName] = faQuestionCircle
icons[faReply.iconName] = faReply
icons[faRoute.iconName] = faRoute
icons[faSearch.iconName] = faSearch
icons[faSave.iconName] = faSave
icons[faShareAlt.iconName] = faShareAlt
icons[faShareSquare.iconName] = faShareSquare
icons[faSquare.iconName] = faSquare
icons[faSignInAlt.iconName] = faSignInAlt
icons[faSignOutAlt.iconName] = faSignOutAlt
icons[faSpinner.iconName] = faSpinner
icons[faStarOfLife.iconName] = faStarOfLife
icons[faStopCircle.iconName] = faStopCircle
icons[faStoreAlt.iconName] = faStoreAlt
icons[faSyncAlt.iconName] = faSyncAlt
icons[faThumbsDown.iconName] = faThumbsDown
icons[faThumbsUp.iconName] = faThumbsUp
icons[faTimes.iconName] = faTimes
icons[faTimesCircle.iconName] = faTimesCircle
icons[faTrash.iconName] = faTrash
icons[faTruck.iconName] = faTruck
icons[faUndo.iconName] = faUndo
icons[faUser.iconName] = faUser
icons[faUserGraduate.iconName] = faUserGraduate
icons[faUserTie.iconName] = faUserTie
icons[faCloudUpload.iconName] = faCloudUpload
icons[faUserCheck.iconName] = faUserCheck

export default icons
